export default "__VITE_ASSET__C4Nc8zJi__"